var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.829,
    height: 25.829,
    viewBox: "0 0 25.829 25.829",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M214.486,206.137a8.374,8.374,0,0,0-4.593-7.457,11.388,11.388,0,0,1-11.213,11.213,8.352,8.352,0,0,0,11.705,3.432l4.064,1.124-1.124-4.064A8.32,8.32,0,0,0,214.486,206.137Zm0,0",
    transform: "translate(-188.657 -188.657)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.862,19.725a9.853,9.853,0,0,1-5.012-1.368L.036,19.687l1.332-4.811a9.863,9.863,0,1,1,8.493,4.849Zm.052-6.47a.726.726,0,1,0,.725.727A.727.727,0,0,0,9.913,13.255Zm-.052-7.2a1.514,1.514,0,0,1,1.022,2.631L9.1,10.312v1.846h1.513V10.977L11.9,9.8a3.027,3.027,0,1,0-5.07-2.232H8.348A1.516,1.516,0,0,1,9.862,6.054Z",
    transform: "translate(0 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.0b4a601df8d2498eeba66a8630613c38.svg";
export { ForwardRef as ReactComponent };